<template>
  <b-card
    :title="$t('label_reports_conventions_title')"
    :style="{ minHeight: height }"
    :class="orientation"
  >
    <ul class="conventions">
      <li class="convention">
        <span class="color positive" />{{
          $t("label_reports_convention_positiveValue")
        }}
      </li>
      <li class="convention">
        <span class="color intermediate" />{{
          $t("label_reports_convention_intermediateValue")
        }}
      </li>
      <li class="convention">
        <span class="color negative" />{{
          $t("label_reports_convention_negativeValue")
        }}
      </li>
      <li class="convention">
        <span class="color notAvailable" />{{
          $t("label_reports_convention_notAvailable")
        }}
      </li>
      <li v-if="showIdeal" class="convention">
        <img src="/static/images/icon_ideal_value.svg" width="20" />{{
          $t("label_reports_convention_idealValue")
        }}
      </li>
      <li v-if="showCompany" class="convention">
        <img src="/static/images/icon_indicator.svg" width="20" />{{
          $t("label_reports_convention_companyValue")
        }}
      </li>
    </ul>
  </b-card>
</template>
<script>
export default {
  name: "CardConventions",
  props: {
    height: {
      type: String,
      default: "auto",
    },
    orientation: {
      type: String,
      default: "",
    },
    showIdeal: {
      type: Boolean,
      default: true,
    },
    showCompany: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.conventions {
  padding-left: 0px;
  margin-bottom: 0;
  .convention {
    font-size: 0.8rem;
    list-style: none;
    .color {
      border-radius: 3px;
      display: inline-block;
      height: 20px;
      margin-right: 5px;
      position: relative;
      top: 5px;
      width: 20px;
    }
    img {
      margin-right: 5px;
    }
  }
}

.horizontal {
  text-align: center;
  h4 {
    display: inline;
    margin-right: 20px;
  }
  .conventions {
    display: inline;
    .convention {
      display: inline;
    }
  }
}
.card-title {
  text-align: left;
}
</style>
